/**
 * Preferência de aparência (LCY_SYS_USERS.blacktheme).
 * 0 = Claro, 1 = Escuro, 2 = Sistema
 */

export const THEME_PREF = {
  LIGHT: 0,
  DARK: 1,
  SYSTEM: 2,
};

export function normalizeBlacktheme(value) {
  if (value === 2 || value === '2') return THEME_PREF.SYSTEM;
  if (value === true || value === 1 || value === '1') return THEME_PREF.DARK;
  return THEME_PREF.LIGHT;
}

export function getSystemPrefersDark() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Resolve preferência persistida → 'light' | 'dark' aplicado na UI. */
export function resolveThemeFromPreference(preference) {
  const pref = normalizeBlacktheme(preference);
  if (pref === THEME_PREF.SYSTEM) {
    return getSystemPrefersDark() ? 'dark' : 'light';
  }
  return pref === THEME_PREF.DARK ? 'dark' : 'light';
}
